import { navigateToSearchSuggestion } from 'owa-options-orchestration';
import { observer } from 'mobx-react';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { OptionWithPath } from 'owa-options-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';

const styles = require('./OptionsFull.scss');

export interface OptionSearchSuggestionProps extends React.HTMLAttributes<HTMLButtonElement> {
    option: OptionWithPath;
}

@observer
export default class OptionSearchSuggestion extends React.Component<
    OptionSearchSuggestionProps,
    {}
> {
    render() {
        let { option } = this.props;

        return (
            <CommandButton
                {...this.props}
                text={strings[option.titleStringKey] as string}
                onClick={this.onSuggestionClick}
                className={styles.suggestion}
            />
        );
    }

    private onSuggestionClick = () => {
        let { option } = this.props;

        navigateToSearchSuggestion(option.categoryKey, option.subcategoryKey, option.key);
    };
}
